export const SIDEBAR_CONST = {
  HOME: 'HOME',
  SETTINGS: 'SETTINGS',
  HELP: 'HELP',
}

export const WIZARD_STEPS = {
  STEP_1: 'STEP_1',
  STEP_2: 'STEP_2',
  STEP_3: 'STEP_3',
}

export const HEADER_CONST = {
  HOME: 'Home',
  PHARMACY_STORE: 'Pharmacy Store',
  MANAGE_CUSTOMER: 'Manage Customer',
  CONSUMER_ORDERS: 'Consumer Orders',
}

export const HEADER_CONFIG = {
  IS_BACK_VISIBLE: 'isBackVisible',
  HANDLE_BACK_FUNC: 'handleBackFunc',
  TITLE: 'title',
}
